// extracted by mini-css-extract-plugin
export default {"bugReportWidget":"bLPGGPwR6mwPZIOlmo7x","row":"cMzkk8189q3gumKoLHnE"};
    if(module.hot) {
      // 1647894309353
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  